import { ArrowRight } from "lucide-react";

const dialogueImage =
  "https://images.pexels.com/photos/5439169/pexels-photo-5439169.jpeg?auto=compress&cs=tinysrgb&w=1600";
const walkingImage =
  "https://images.pexels.com/photos/5439148/pexels-photo-5439148.jpeg?auto=compress&cs=tinysrgb&w=1200";

export default function Vision() {
  return (
    <section
      data-testid="vision-section"
      className="border-b border-black/10 bg-white"
    >
      <div className="max-w-[1440px] mx-auto grid grid-cols-1 lg:grid-cols-12">
        <div className="lg:col-span-7 relative min-h-[420px] lg:min-h-[640px] order-2 lg:order-1">
          <img
            src={dialogueImage}
            alt="Coaching-Gespräch — zwei Personen im Dialog"
            className="absolute inset-0 w-full h-full object-cover grayscale contrast-110"
          />
          <div className="absolute inset-0 bg-[#0A0A0A]/15" />
          <div className="absolute bottom-6 left-6 right-6 flex items-center justify-between text-white text-xs uppercase tracking-[0.25em] font-semibold">
            <span>Begleiten · Entwickeln</span>
            <span className="font-mono">04 / 04</span>
          </div>
        </div>

        <div className="lg:col-span-5 section-padding flex flex-col justify-center order-1 lg:order-2 lg:border-l border-black/10">
          <div className="overline mb-6">Mein Anspruch</div>
          <h2 className="font-display font-bold text-3xl sm:text-4xl md:text-[44px] tracking-tight leading-[1.05]">
            Menschen
            <br />
            <span className="text-[#D30000]">weiterentwickeln</span>
            <br />
            und sie begleiten.
          </h2>

          <p className="mt-8 text-base md:text-lg leading-relaxed text-[#4A4A52] max-w-md">
            Mein Ziel ist nicht das Verteilen von Methoden, sondern das
            Begleiten von Persönlichkeiten. Wachstum entsteht im Dialog —
            durch Klarheit über die eigene Rolle, durch innere Stabilität und
            den Mut, die übertragene Verantwortung wirklich anzunehmen.
          </p>

          <ul className="mt-10 space-y-4 max-w-md">
            <li className="flex items-start gap-4 text-sm md:text-base">
              <span className="font-mono text-xs text-[#D30000] pt-1">01</span>
              <span className="text-[#0A0A0A]">
                Persönliches Sparring auf Augenhöhe
              </span>
            </li>
            <li className="flex items-start gap-4 text-sm md:text-base border-t border-black/10 pt-4">
              <span className="font-mono text-xs text-[#D30000] pt-1">02</span>
              <span className="text-[#0A0A0A]">
                Entwicklung in der eigenen Geschwindigkeit
              </span>
            </li>
            <li className="flex items-start gap-4 text-sm md:text-base border-t border-black/10 pt-4">
              <span className="font-mono text-xs text-[#D30000] pt-1">03</span>
              <span className="text-[#0A0A0A]">
                Wachsen an Verantwortung — statt sie abzuarbeiten
              </span>
            </li>
          </ul>

          <a
            href="#kontakt"
            className="mt-12 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.2em] hover-marker w-fit"
            data-testid="vision-cta"
          >
            Gespräch beginnen <ArrowRight size={16} />
          </a>
        </div>
      </div>

      <div className="max-w-[1440px] mx-auto grid grid-cols-1 lg:grid-cols-12 border-t border-black/10">
        <div className="lg:col-span-5 section-padding flex flex-col justify-center">
          <div className="overline mb-6">Haltung</div>
          <p className="font-display text-2xl md:text-3xl tracking-tight leading-snug text-[#0A0A0A] max-w-md">
            „Es geht um das Begleiten der Person in ihrer Individualität —
            ausgeglichener und erfolgreicher aus der persönlichen Mitte
            heraus.&rdquo;
          </p>
          <div className="mt-6 text-xs uppercase tracking-[0.2em] text-[#4A4A52]">
            Michael Horgas
          </div>
        </div>

        <div className="lg:col-span-7 relative min-h-[360px] lg:min-h-[520px] lg:border-l border-black/10">
          <img
            src={walkingImage}
            alt="Zwei Personen im professionellen Austausch"
            className="absolute inset-0 w-full h-full object-cover grayscale contrast-110"
          />
          <div className="absolute inset-0 bg-[#0A0A0A]/10" />
        </div>
      </div>
    </section>
  );
}
